import $ from 'jquery'
import { PageConfig } from "./shared/config/page-config";

export class App {

    /**
     * @param pageConfig {PageConfig}
     * */
    constructor(pageConfig) {
        this._pageConfig = pageConfig;
        this.init()
    }

    init() {
        // when load page
        $(() => {
            this.handler.init();
        })
    }

    get handler() {
        return new Proxy(this._pageConfig.handler, {
            get: (handler, prop) => {
                if (typeof handler[prop] === 'function') {
                    return handler[prop].bind(handler);
                }
                else {
                    return handler[prop];
                }
            },
        })
    }

    get code() {
        return this._pageConfig.internalCode;
    }
}